/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-11 16:17:34
 * @LastEditTime: 2025-02-17 17:08:21
 * @LastEditors: ywj@originqc.com
 */

import request from '@/utils/request';

// banner和推荐位
export const getPropose = (): any =>
  request({
    url: 'product/propose.json',
  });
  
// 商品分类
  export const getCategory = (id:number): any =>
  request({
    url: 'product/category.json?id='+id,

  });

  // 首页商品查询
export const getHomeGoods = (): any =>
request({
  url: 'product/home.json',
});